import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { withNamespaces } from 'react-i18next';

import {Constants} from '../../common/constants';
import elpPathService from '../../common/elpPathService';

const { home, common } = Constants;
const { ASC } = common;
const { COLUMN_SORT_NAMES } = home;
const { APP_NAME, APP_DESCRIPTION, CONSTITUENT_TYPE, SEARCH_TERM, PROVIDED_BY } = COLUMN_SORT_NAMES;

class ApplicationTable extends Component {
  static propTypes = {
    applications: PropTypes.array,
    sortCol: PropTypes.string,
    sortDir: PropTypes.string,
    onSort: PropTypes.func
  };

  constructor(props){
    super(props);

    this.renderSortIcon = this.renderSortIcon.bind(this);
    this.renderHeaderCell = this.renderHeaderCell.bind(this);
  }

  componentDidMount() {
    this.props.onSort(APP_NAME, ASC);
  }

  handleSortClick = (e) => {
    const { id } = e.currentTarget;
    this.props.onSort(id);
  };

  renderSortIcon(name){
    const { sortCol, sortDir } = this.props;
    let icon = faSort;

    if(name === sortCol){
      icon = sortDir === ASC ? faSortDown : faSortUp; 
    }

    return <FontAwesomeIcon icon={icon} title="Sort Column"/>
  }

  renderHeaderCell({name, label}){
    const { onSort } = this.props;

    return (
      <th 
        className="home-application-table__header home-application-table__cell"
        key={`id-${name}`}
      >
        <span className="text-nowrap">
          {label}&nbsp;
          <span id={name} className="home-application-table__sort-icon ml-1 cursor-pointer" tabIndex="0" onClick={this.handleSortClick} onKeyPress={this.handleSortClick}>
            {this.renderSortIcon(name)}
          </span>
        </span>
      </th>
    );
  }

  render() {
    const { applications, t } = this.props;

    const tableHeaders = [
      {
        name: APP_NAME,
        label: t('application_table.app_name')
      },
      {
        name: APP_DESCRIPTION,
        label: t('application_table.app_description')
      },
      {
        name: CONSTITUENT_TYPE,
        label: t('application_table.constituent_type')
      },
      {
        name: SEARCH_TERM,
        label: t('application_table.search_term')
      },
      {
        name: PROVIDED_BY,
        label: t('application_table.provided_by')
      }
    ];

    if(!applications.length){
      return <h3 className="text-center">{ t('application_table.no_results')}</h3>
    }

    return (
      <div className="home-application-table">
  
          <table className="usa-table">
            <thead>
              <tr className="home-application-table__row font-body-xs">
                {tableHeaders.map(this.renderHeaderCell)}
              </tr>
            </thead>
            <tbody>
              {
                applications.map(application => {
                  return (
                    <tr className="home-application-table__row" key={application.id}>
                      <td className="home-application-table__cell">
                        <a href={elpPathService.getApplicationPath(application.vanity_url)} target="_blank" className="usa-link">
                          {application[APP_NAME]}
                        </a>
                      </td>
                      <td className="home-application-table__cell">
                        <div dangerouslySetInnerHTML={{ __html: application[APP_DESCRIPTION] }} className="overflow-wrap-anywhere" />
                      </td>
                      <td className="home-application-table__cell">{application[CONSTITUENT_TYPE]}</td>
                      <td className="home-application-table__cell">{application[SEARCH_TERM]}</td>
                      <td className="home-application-table__cell">
                        <a href={application.agency_url} target="_blank" className="usa-link">
                          {application[PROVIDED_BY]}
                        </a>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        
      </div>
    );
  }
}

export default withNamespaces('home')(ApplicationTable);



// WEBPACK FOOTER //
// ./src/features/home/ApplicationTable.js